<script>
export default {
    name: "Auction",
    props: ['auction', 'deal'],
    data() {
        return {
            csrf_token: window.CSRF
        }
    }
}
</script>

<template>
    <div>
        <p>Starting Price: {{ auction.starting_price }} {{ deal.currency === '-' ? 'GBP' : deal.currency }}</p>
        <p>Bid Increment: {{ auction.minimum_bid_step }} {{ deal.currency === '-' ? 'GBP' : deal.currency }}</p>
        <form _lpchecked="1" method="post" :action="route('deal.bid.store', deal)">
            <input type="hidden" name="_token" :value="csrf_token">
            <div class="flex flex-wrap -mx-3 mb-4">
                <div class="w-full px-3"><label class="block text-black text-sm font-medium mb-1"
                                                for="bid_amount">Bid Amount ({{ deal.currency === '-' ? 'GBP' : deal.currency }})</label>
                    <input id="bid_amount" type="number" name="amount" class="s w-full text-black" :value="auction.next_step" required
                           autocomplete="name" autofocus placeholder="Amount (e.g. 15,000)" style="outline: none;">
                </div>
            </div>

            <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
                <button type="submit"
                    class="flex rounded-md w-full items-center justify-center border border-transparent bg-opacity-90 bg-fwdarkpurple px-8 py-3 text-base font-medium text-white hover:bg-opacity-100 focus:outline-none focus:ring-2 focus:ring-fwdarkpurple focus:ring-offset-2 focus:ring-offset-gray-50">
                    Place Bid
                </button>
            </div>
        </form>

        <form _lpchecked="1" method="post" :action="route('deal.auto-bid.store', deal)">
            <input type="hidden" name="_token" :value="csrf_token">
            <div class="flex flex-wrap -mx-3 mb-4">
                <div class="w-full px-3"><label class="block text-black text-sm font-medium mb-1"
                                                for="auto_amount">Bid Limit({{ deal.currency === '-' ? 'GBP' : deal.currency }})</label>
                    <input id="auto_amount" type="number" name="auto_amount" class="s w-full text-black" :value="auction.next_step" required
                           autocomplete="name" autofocus placeholder="Automatically Bid up to a set amount" style="outline: none;">
                </div>
            </div>

            <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
                <button type="submit"
                        class="flex rounded-md w-full items-center justify-center border border-transparent bg-opacity-90 bg-fwdarkpurple px-8 py-3 text-base font-medium text-white hover:bg-opacity-100 focus:outline-none focus:ring-2 focus:ring-fwdarkpurple focus:ring-offset-2 focus:ring-offset-gray-50">
                    Set Bid Limit
                </button>
            </div>
        </form>



    </div>
</template>

<style scoped>

</style>
